import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download1",
  "use": "icon-download1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download1\"><defs><style type=\"text/css\"></style></defs><path d=\"M864 832h-704a32 32 0 0 0 0 64h704a32 32 0 0 0 0-64zM801.28 400.64H640V161.92A33.92 33.92 0 0 0 606.08 128h-192a33.92 33.92 0 0 0-30.08 33.92v238.72H222.72a30.08 30.08 0 0 0-21.76 51.84l289.28 289.92a32 32 0 0 0 43.52 0l289.28-289.92a30.08 30.08 0 0 0-21.76-51.84z\" p-id=\"3846\" fill=\"#4934b2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol